// components/Breadcrumbs.jsx
import { Link } from 'react-router-dom';

export default function Breadcrumbs({ items = [] }) {
  if (!items.length) return null;

  return (
    <nav
      className="mb-6 overflow-x-auto scrollbar-hide"
      aria-label="סימני דרך"
    >
      <ol className="flex items-center gap-2 text-sm whitespace-nowrap">
        {items.map((it, i) => {
          const isLast = i === items.length - 1;

          return (
            <li key={i} className="flex items-center gap-2">
              {i > 0 && (
                <svg
                  className="w-4 h-4 text-secondary-400 dark:text-secondary-500 rtl:rotate-180"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              )}

              {isLast || !it.to ? (
                <span className={`
                  ${isLast
                    ? 'text-secondary-900 dark:text-white font-medium'
                    : 'text-secondary-500 dark:text-secondary-400'
                  }
                `}>
                  {it.label}
                </span>
              ) : (
                <Link
                  to={it.to}
                  className="
                    text-secondary-500 dark:text-secondary-400
                    hover:text-primary-600 dark:hover:text-primary-400
                    transition-colors duration-150
                  "
                >
                  {it.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}